<script setup lang="ts">
defineProps<{
  variant: SingleProductVariant
}>()
</script>

<template>
  <UiCartAddWidget
    v-if="variant.isPurchasable"
    class="anti-padded"
    :variant="variant"
    dir="horizontal"
  />
  <div v-else class="cta anti-padded">
    <span>Fysiske bøker selges hos forhandler:</span>
    <UButton
      class="rounded-full bg-yellow-legacy-30 px-legacy-m py-legacy-xs text-[--ui-text] no-underline hover:bg-yellow-legacy-40"
      :href="`https://www.norli.no/${variant.isbn}`"
      target="_blank"
      trailing-icon="far:external-link"
      :ui="{
        trailingIcon: 'size-3.5',
      }"
    >
      Kjøp boka hos Norli
    </UButton>
  </div>
</template>

<style scoped>
@reference "~/assets/styles/main.css";

.anti-padded {
  --anti-padding: calc((var(--outer-padding) + var(--inner-padding)) * -1);

  @media screen and (max-width: theme('screens.md')) {
    border-radius: 0 !important;
    margin-inline: var(--anti-padding);
    margin-bottom: var(--anti-padding);
  }
}

div {
  display: flex;
  gap: 0.6rem;
  --padding-inline: var(--spacing-legacy-s);
  --padding-block: var(--spacing-legacy-m);

  @media screen and (min-width: theme('screens.md')) {
    --padding-block: theme('spacing.5');
    --padding-inline: theme('spacing.5');
  }

  &.cta {
    flex-wrap: wrap;
    /* TODO: Verify that this works */
    background: rgba(white, 0.9);
    justify-content: space-between;
    align-items: center;
    padding-block: var(--padding-block);
    padding-inline: var(--padding-inline);
    border-radius: 0.625rem;
    container-type: inline-size;

    @media screen and (min-width: theme('screens.md')) {
      /* To align text instead of container */
      margin-left: calc(var(--padding-inline) * -1);
    }

    > * {
      margin: auto;
    }

    @container (width > 33rem) {
      > * {
        margin: initial;
      }
    }

    > span {
      font-size: 1rem;
      font-weight: 600;
    }
  }
}
</style>
